import authHelper from '../helpers/auth';
// import encryption from '@/api/encryption';

export default {
	noAuth(config) {
		// config.headers.ReferenceToken = encryption.encrypt(navigator.userAgent.replace(/[^0-9]/g, ''), `${window.location.protocol}//${window.location.hostname}${(location.port ? ':'+location.port: '')}`);
		const token = authHelper.getToken();

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},

	auth(config) {
		const token = authHelper.getToken();
		config.headers.Authorization = `Bearer ${token}`;
		// config.headers.ReferenceToken = encryption.encrypt(navigator.userAgent.replace(/[^0-9]/g, ''), `${window.location.protocol}//${window.location.hostname}${(location.port ? ':'+location.port: '')}`);

		return config;
	},

	onError(err) {
		return Promise.reject(err);
	},
};
